<template>
  <div
    class="browser-message"
    :class="isBrowserMessageVisible ? 'is-visible' : 'is-hidden'"
  >
    <p class="mb-0 max-w-4xl">
      {{ msg }}
      <kf-button
        class="text-white underline hover:no-underline"
        @click.prevent="gotoLiveChat"
      >
        {{ linkLabel }}
      </kf-button>
    </p>
    <kf-button
      class="btn-close"
      aria-label="close browser message"
      @click="hideBrowserMessage"
    >
      <close-icon class="icon" />
    </kf-button>
  </div>
</template>

<script>
const cookieName = 'browser_message_removed';
import Utils from '@/lib/utils';
import CloseIcon from './svg/CloseIcon.vue';

export default {
  name: 'BrowserMessage',
  components: {
    CloseIcon,
    KfButton: () => import(/* webpackChunkName: "main" */ '@/components/base/button/Button.vue'),
  },
  props: {
    msg: {
      type: String,
      default: '',
    },
    linkLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      browserLanguage: '',
      isBrowserMessageVisible: false,
      isBrowserMessageRemoved: false,
    };
  },
  mounted: async function() {
    await this.getBrowserLang();
    this.showBrowserMessage();
  },
  methods: {
    getBrowserLang() {
      this.browserLanguage = navigator.language.split('-')[0];
    },
    showBrowserMessage() {
      if (this.$cookies.get(cookieName) === null) {
        setTimeout(() => {
          if (this.browserLanguage !== 'nl' && this.browserLanguage !== 'en') {
            this.isBrowserMessageVisible = true;
          }
        }, 1000);
      }
    },
    hideBrowserMessage() {
      this.isBrowserMessageVisible = false;
      this.$cookies.set(cookieName, true, '1y');
    },
    gotoLiveChat() {
      let newUrl = Utils.queryString.update('livechat', 'true', '/');
      window.location = newUrl;
      this.hideBrowserMessage();
    },
  },
};
</script>

<style lang="postcss" scoped>
.browser-message {
  @apply fixed top-0 w-full z-50 bg-primary-bravo flex justify-center items-center px-8 py-2;
  transition: transform 300ms;
  min-height: 55px;

  @screen md {
    height: 120px;
  }

  @screen lg {
    @apply px-0;
  }

  &.is-visible {
    transform: translateY(0);
  }

  &.is-hidden {
    transform: translateY(-100%);
  }

  p {
    @apply text-white;
  }

  .btn-close {
    @apply absolute;
    top: 10px;
    right: 10px;

    @screen md {
      top: 20px;
      right: 20px;
    }

    .icon {
      fill: #ffffff;
      color: #ffffff;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
